import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageObserve extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    // console.log("PageObserve");    

    // dispaccio un evento glo  bale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    }
    catch {
      console.error();
    }
  } 
}